function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoTelegramBlack = function SvgLogoTelegramBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256,512C397.419,512 512,397.419 512,256C512,114.581 397.419,0 256,0C114.581,0 0,114.581 0,256C0,397.419 114.581,512 256,512ZM117.141,250.453L363.968,155.285C375.424,151.147 385.429,158.08 381.717,175.403L381.739,175.381L339.712,373.376C336.597,387.413 328.256,390.827 316.587,384.213L252.587,337.045L221.717,366.784C218.304,370.197 215.424,373.077 208.811,373.077L213.355,307.947L331.968,200.789C337.131,196.245 330.816,193.685 324.011,198.208L177.429,290.496L114.24,270.784C100.523,266.432 100.224,257.067 117.141,250.453Z",
    style: {
      fill: "rgb(39,160,223)",
      fillRule: "nonzero"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoTelegramBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-telegram-black.ae621c28.svg";
export { ForwardRef as ReactComponent };